module.exports = __webpack_public_path__ + "img/inco5.e4a7cc1f.png";